export default __webpack_public_path__ + "static/media/linkedin.b1bebb39.png";